<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Open Batch</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <OpenBatchForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import OpenBatchForm from "../../components/Kleyton/Forms/Journal/OpenBatchForm";

export default {
  page: {
    title: "Open Batch",
    meta: [{ name: "Open Batch", content: window.__env.app.description }]
  },

  components: {
    OpenBatchForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "OpenBatch",
      title: "Open Batch",
      items: [
        {
          text: "Batch",
          href: "/"
        },
        {
          text: "Open Batch",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
